// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"7422c45f","453":"b03e3c98","488":"78c2f9d5","553":"88b293e4","977":"d7613599"}[chunkId] + ".chunk.js";
};